import { mapGetters, mapActions, mapMutations } from 'vuex'

import parseData from '@/utils/parseData'
import tooltips from '@/utils/tooltips'
import calcMetrics from '@/utils/calcMetrics'
import { alerts, statuses, priorities, funnel, actions, types, intents } from '@/utils/clusterVariables.js'
import ClusterCard from '@/components/ClusterCard/ClusterCard.vue'
import SnackbarAction from '@/components/SnackbarAction/SnackbarAction.vue'

export default {
  name: 'Plan',
  components: {
    ClusterCard,
    SnackbarAction
  },
  data () {
    return {
      isLoading: {
        excludeKeyword: false,
        resetKeyword: false,
        topicPost: false,
        renameTopic: false,
        excludeTopic: false,
        deleteTopic: false,
        moveKeywords: false,
        moveArticles: false,
        renameArticle: false,
        mergeArticles: false,
        addToMap: false,
        deleteArticles: false,
        dismissArticles: false,
        changeArticleTags: false,
        newArticle: false,
        score: false,
        articles: false,
        keywords: false,
        updateTarget: false,
        lockingArticle: false,
        excludePages: false,
        updatePageAction: false,
        articleUrls: false,
        alerts: false,
        updatePageMergeWith: false,
        mutatingArticles: false
      },

      tableArticles: {
        isLoading: false,
        headers: [
          { text: 'URL', value: 'article_url' },
          { text: 'Cluster', value: 'title' },
          { text: 'Status', value: 'status' },
          { text: 'Page type', value: 'type' },
          { text: 'Relevance', value: 'relevance' },
          { text: 'Search Volume', value: 'estimated_search_volume' },
          { text: 'Actions', value: 'actions' }
        ]
      },
      tableArticlesOptions: {
        itemsPerPage: 50,
        page: 1,
        sortBy: ['relevance'],
        sortDesc: [true]
      },

      selectedTopic: null,
      selectedKeywords: [],
      selectedArticles: [],
      selectedPages: [],
      selectedKeyword: [],
      selectAllArticles: false,
      selectAllPages: false,
      selectableTargetUrls: [],
      selectableTargetArticles: [],

      topicFilter: null,
      actionFilter: '',
      newOrExistingFilter: null,
      trending: false,
      losing: false,

      switchGridView: false,
      showExistingPageShortcuts: false,
      showNewPageShortcuts: true,
      showTopics: false,
      newPageShortcuts: [
        { text: 'Recently added', value: 'recently-added' },
        { text: 'Breakout pages', value: 'breakout-pages' },
        { text: 'Zero impressions', value: 'zero-impressions' },
        { text: 'Not in favorites', value: 'not-mapped' }
      ],
      selectedNewPageShortcut: null,

      statuses,
      priorities,
      funnel,
      alerts,
      actions,

      metrics: [
        { text: 'Relevance', value: 'relevance', ranges: [0, 3, 5, 7, 10] },
        { text: 'Search Volume', value: 'estimated_search_volume', ranges: [0, 100, 1000, 10000] },
        { text: 'Potential Clicks', value: 'potential_clicks', ranges: [0, 100, 1000, 10000] },
        { text: '# of Keywords', value: 'keyword_count', ranges: [0, 10, 30, 100] },
        { text: 'URL Impressions', value: 'page_impressions_last', ranges: [0, 100, 1000, 10000] },
        { text: 'URL Clicks', value: 'page_clicks_last', ranges: [0, 10, 100, 1000] },
        { text: 'URL CTR', value: 'page_ctr_last', ranges: [0, 1, 5, 10] },
        { text: 'URL Rank', value: 'page_position_last', ranges: [1, 3, 10, 30] },
        { text: 'URL Impressions Change', value: 'page_impressions_change', ranges: [-1000, -100, 0, 100, 1000] },
        { text: 'URL Clicks Change', value: 'page_clicks_change', ranges: [-100, -10, 0, 10, 100] },
        { text: 'URL CTR Change', value: 'page_ctr_change', ranges: [-10, -5, 0, 5, 10] },
        { text: 'URL Rank Change', value: 'page_position_change', ranges: [-30, -10, 0, 10, 30] },
        { text: 'Cluster Match Impressions', value: 'target_impressions', ranges: [0, 100, 1000, 10000] },
        { text: 'Cluster Match Clicks', value: 'target_clicks', ranges: [0, 10, 100, 1000] },
        { text: 'Cluster Match CTR', value: 'target_ctr', ranges: [0, 1, 5, 10] },
        { text: 'Cluster Match Rank', value: 'target_position', ranges: [1, 3, 10, 30] },
        { text: 'Cluster Impressions', value: 'google_impressions_last', ranges: [0, 100, 1000, 10000] },
        { text: 'Cluster Clicks', value: 'google_clicks_last', ranges: [0, 10, 100, 1000] },
        { text: 'Cluster CTR', value: 'google_ctr_last', ranges: [0, 1, 5, 10] },
        { text: 'Cluster Rank', value: 'google_position_last', ranges: [1, 3, 10, 30] },
        { text: 'Cluster Impressions Change', value: 'google_impressions_change', ranges: [-1000, -100, 0, 100, 1000] },
        { text: 'Cluster Clicks Change', value: 'google_clicks_change', ranges: [-100, -10, 0, 10, 100] },
        { text: 'Cluster CTR Change', value: 'google_ctr_change', ranges: [-10, -5, 0, 5, 10] },
        { text: 'Cluster Rank Change', value: 'google_position_change', ranges: [-30, -10, 0, 10, 30] },
        { text: 'Cluster Match Rate', value: 'cluster_match_rate', ranges: [0, 10, 30, 100] }
      ],
      dimensions: [
        { text: 'Mapped', value: 'show_in_map', type: 'select', options: [{ text: 'Yes', value: true }, { text: 'No', value: false }] },
        { text: 'Action', value: 'suggested_action', type: 'select', options: actions },
        { text: 'Status', value: 'status', type: 'select', options: statuses },
        { text: 'Priority', value: 'priority', type: 'select', options: priorities },
        { text: 'Funnel', value: 'funnel', type: 'select', options: funnel },
        { text: 'Page type', value: 'type', type: 'select', options: types },
        { text: 'Search intent', value: 'intent', type: 'select', options: intents },
        { text: 'Publish date', value: 'published_at', type: 'date' },
        { text: 'Created at', value: 'created_at', type: 'date' },
        { text: 'Status code', value: 'status_code', type: 'select', options: [200, 301, 302, 308, 403, 404, 503] },
        { text: 'Alerts', value: 'alerts', type: 'select-boolean', options: alerts }
      ],

      metricFilters: [
        { text: 'Search Volume', value: 'estimated_search_volume', ranges: [0, 100, 1000, 10000], min: null, max: null },
        { text: 'Potential Clicks', value: 'potential_clicks', ranges: [0, 100, 1000, 10000], min: null, max: null }
      ],
      dimensionFilters: [
        { text: 'Publish date', value: 'published_at', type: 'date', filter: [null, null] },
        { text: 'Priority', value: 'priority', type: 'select', options: priorities, filter: ['high', 'not set'] }
      ],
      textFilters: [
        { text: 'Cluster', value: 'title', filter: '' },
        { text: 'URL', value: 'article_url', filter: '' },
        { text: 'Keyword', value: 'keyword', filter: '' }
      ],

      selectedMetrics: [
        { text: 'Relevance', value: 'relevance' },
        { text: 'Search Volume', value: 'estimated_search_volume' }
      ],
      selectedDimensions: [
        { text: 'Status', value: 'status' },
        { text: 'Page type', value: 'type' }
      ],

      rules: {
        topicName: value => this.topics?.filter(topic => topic.name === value).length === 0 || 'Topic name already exists.',
        articleName: value => this.articles?.filter(article => article.title === value).length === 0 || 'Article title already exists.'
      },

      topicNewName: null,
      articleNewName: null,
      keywordsNewArticle: null,
      articlesNewTopicId: null,
      articlesNewPriority: null,
      articlesNewFunnel: null,
      articlesNewStatus: null,
      articlesNewPageId: null,
      pageNewArticleId: null,
      articleChangeUrl: null,
      topicAddAndMoveArticle: false,
      articleAddAndMoveKeyword: false,
      articlePage: 1,
      articlePageLength: 9,
      articleAddForm: false,
      topicAddForm: false,

      showTopicRename: false,
      showTopicExclude: false,
      showTopicReset: false,
      showTopicAdd: false,
      showKeywordMove: false,
      showArticleRename: false,
      showArticlePriority: false,
      showArticleFunnel: false,
      showArticleStatus: false,
      showArticleMove: false,
      showArticleAdd: false
    }
  },
  mixins: [calcMetrics],
  computed: {
    ...mapGetters([
      'topics',
      'topic',
      'score',
      'articles',
      'articlesTotalCount',
      'keywords',
      'activeContentplan',
      'activeWorkspace',
      'pages',
      'articleUrls',
      'role',
      'keywordsDict',
      'contentplanAboutInfo'
    ]),
    workspaceId () {
      return parseInt(this.$route.params.workspaceId)
    },
    contentplanId () {
      return parseInt(this.$route.params.contentplanId)
    },
    contentplanName () {
      return this.activeContentplan?.name
    },
    remainingCredits () {
      return this.activeWorkspace?.remaining_article_credits
    },
    snackbarKeywords: {
      get () {
        return this.selectedKeywords?.length > 0
      },
      set (value) {
        if (!value) {
          this.selectedKeywords = []
        }
      }
    },
    snackbarArticles: {
      get () {
        return this.selectedArticles?.length > 0
      },
      set (value) {
        if (!value) {
          this.selectedArticles = []
        }
      }
    },
    snackbarPages: {
      get () {
        return this.selectedPages?.length > 0
      },
      set (value) {
        if (!value) {
          this.selectedPages = []
        }
      }
    },
    snackbarMetrics: {
      get () {
        return this.selectedKeywords?.length > 0 || this.selectedArticles?.length > 0 || this.selectedPages?.length > 0
      },
      set (value) {
        // This is just a placeholder setter since we don't actually need to set this value
        // but we need a setter for Vue's reactivity system
      }
    },
    selectableArticles () {
      return this.articles.map(a => ({ text: a.title, value: a.article_id }))
    },
    selectableTopics () {
      if (!this.topics) return

      return this.topics.map(a => ({ text: a.name, value: a.id, count: a.article_count })).filter(a => (a.value !== this.topicFilter))
    },
    totalCount () {
      return this.articlesTotalCount || 0
    },
    activeFilterCount () {
      let count = 0

      if (this.titleFilter) count++
      if (this.keywordFilter) count++
      if (this.urlFilter) count++
      if (this.volumeFilter[0] || this.volumeFilter[1]) count++
      if (this.positionFilter[0] || this.positionFilter[1]) count++
      if (this.ctrFilter[0] || this.ctrFilter[1]) count++
      if (this.potentialFilter[0] || this.potentialFilter[1]) count++
      if (this.statusFilter.length) count++
      if (this.priorityFilter.length) count++
      if (this.funnelFilter.length) count++
      if (this.alertsFilter.length) count++

      return count
    },
    createFiltersObject () {
      const filters = [{ field: 'contentplanId', op: 'eq', value: this.contentplanId }]
      const or = []

      const metricFieldMap = {
        keyword_count: 'keywordCount',
        estimated_search_volume: 'estimatedSearchVolume',
        potential_clicks: 'potentialClicks',
        page_impressions_last: 'pageImpressionsLast',
        page_clicks_last: 'pageClicksLast',
        page_ctr_last: 'pageCtrLast',
        page_position_last: 'pagePositionLast',
        page_impressions_change: 'pageImpressionsChange',
        page_clicks_change: 'pageClicksChange',
        page_ctr_change: 'pageCtrChange',
        page_position_change: 'pagePositionChange',
        target_impressions: 'targetImpressions',
        target_clicks: 'targetClicks',
        target_ctr: 'targetCtr',
        target_position: 'targetPosition',
        google_impressions_last: 'googleImpressionsLast',
        google_impressions_change: 'googleImpressionsChange',
        google_clicks_last: 'googleClicksLast',
        google_clicks_change: 'googleClicksChange',
        google_ctr_last: 'googleCtrLast',
        google_ctr_change: 'googleCtrChange',
        google_position_last: 'googlePositionLast',
        google_position_change: 'googlePositionChange',
        relevance: 'relevance'
      }

      const dimensionFieldMap = {
        show_in_map: 'showInMap',
        suggested_action: 'action',
        status: 'status',
        priority: 'priority',
        funnel: 'funnel',
        type: 'type',
        intent: 'intent',
        published_at: 'publishedAt',
        created_at: 'createdAt',
        status_code: 'statusCode'
      }

      // Process metric filters
      this.metricFilters.forEach((f) => {
        const field = metricFieldMap[f.value]
        if (!field) return
        if (f.min !== null && f.min !== undefined) {
          filters.push({ field, op: 'gte', value: parseFloat(f.min) })
        }
        if (f.max !== null && f.max !== undefined) {
          filters.push({ field, op: 'lte', value: parseFloat(f.max) })
        }
      })

      // Process dimension filters
      this.dimensionFilters.forEach((f) => {
        if (f.type === 'select') {
          const field = dimensionFieldMap[f.value]
          if (!field || f.filter === undefined || f.filter === null) return
          if (Array.isArray(f.filter) && f.filter.length === 0) return
          if (Array.isArray(f.filter)) {
            filters.push({ field, op: 'in', value: f.filter })
          } else {
            filters.push({ field, op: 'eq', value: f.filter })
          }
        }
        if (f.type === 'date') {
          const field = dimensionFieldMap[f.value]
          if (!field) return
          if (f.filter[0]) {
            filters.push({ field, op: 'gte', value: f.filter[0] })
          }
          if (f.filter[1]) {
            filters.push({ field, op: 'lte', value: f.filter[1] })
          }
        }
      })

      // Process text filters
      this.textFilters.forEach((f) => {
        if (!f.filter) return
        const textFieldMap = {
          title: 'title',
          article_url: 'articleUrl',
          keyword: 'keyword'
        }
        const field = textFieldMap[f.value]
        if (!field) return
        filters.push({ field, op: 'regexp', value: f.filter })
      })

      if (this.topicFilter) {
        filters.push({ field: 'topicId', op: 'eq', value: this.topicFilter })
      }

      if (this.actionFilter) {
        filters.push({ field: 'action', op: 'eq', value: this.actionFilter })
      }

      if (this.newOrExistingFilter) {
        filters.push({ field: 'hasPage', op: 'is_null', value: this.newOrExistingFilter === 'new' })
      }

      const sortFieldMap = {
        estimated_search_volume: 'estimatedSearchVolume',
        google_impressions_last: 'googleImpressionsLast',
        google_impressions_change: 'googleImpressionsChange',
        google_clicks_last: 'googleClicksLast',
        google_clicks_change: 'googleClicksChange',
        google_ctr_last: 'googleCtrLast',
        google_ctr_change: 'googleCtrChange',
        google_position_last: 'googlePositionLast',
        google_position_change: 'googlePositionChange',
        page_impressions_last: 'pageImpressionsLast',
        page_impressions_change: 'pageImpressionsChange',
        page_clicks_last: 'pageClicksLast',
        page_clicks_change: 'pageClicksChange',
        page_ctr_last: 'pageCtrLast',
        page_ctr_change: 'pageCtrChange',
        page_position_last: 'pagePositionLast',
        page_position_change: 'pagePositionChange',
        title: 'title',
        status: 'status',
        priority: 'priority',
        funnel: 'funnel',
        type: 'type',
        intent: 'intent',
        created_at: 'createdAt'
      }

      const sortField = sortFieldMap[this.sortBy] || 'estimatedSearchVolume'
      const sortDirection = this.sortDesc === 'desc' ? 'desc' : 'asc'

      const limit = this.itemsPerPage
      const page = this.itemsPage
      const pagination = {
        limit,
        offset: Math.max(page - 1, 0) * limit
      }

      return {
        contentplanId: this.contentplanId,
        filters,
        or,
        sort: [{ field: sortField, direction: sortDirection }],
        pagination,
        includeKeywords: this.switchGridView,
        includeExtendedMetrics: true
      }
    },
    itemsPerPage () {
      if (this.switchGridView) return this.articlePageLength

      return this.tableArticlesOptions.itemsPerPage
    },
    itemsPage () {
      if (this.switchGridView) return this.articlePage

      return this.tableArticlesOptions.page
    },
    sortBy () {
      let sortBy
      if (this.switchGridView) {
        sortBy = this.selectedMetrics[0].value
      } else {
        sortBy = this.tableArticlesOptions.sortBy[0]
      }

      if (sortBy === 'undefined') {
        sortBy = null
      }

      return sortBy
    },
    sortDesc () {
      if (this.switchGridView) return 'desc'

      return this.tableArticlesOptions.sortDesc[0] ? 'desc' : 'asc'
    },
    leftNavActions () {
      return this.actions.filter(a => a.value !== 'not-enough-data')
    },
    // Keyword actions for snackbar
    keywordActions () {
      if (this.showKeywordMove) {
        return [
          {
            text: `Move ${this.selectedKeywords.length} ${this.selectedKeywords.length > 1 ? 'keywords' : 'keyword'}`,
            event: 'move-keywords',
            loading: this.isLoading.moveKeywords,
            disabled: !this.keywordsNewArticle
          }
        ]
      } else {
        return [
          { text: 'Move', event: 'show-keyword-move' },
          { text: 'Reset', event: 'reset-keywords', loading: this.isLoading.resetKeyword },
          { text: 'Exclude', event: 'exclude-keywords', loading: this.isLoading.excludeKeyword }
        ]
      }
    },
    // Title for keywords snackbar
    keywordTitle () {
      return `${this.selectedKeywords.length} ${this.selectedKeywords.length > 1 ? 'keywords' : 'keyword'} selected`
    },
    // Actions for articles snackbar
    articleActions () {
      if (this.showArticleMove) {
        return [
          {
            text: `Move ${this.selectedArticles.length} ${this.selectedArticles.length > 1 ? 'Clusters' : 'Cluster'}`,
            event: 'move-articles',
            loading: this.isLoading.moveArticles,
            disabled: !this.articlesNewTopicId
          }
        ]
      } else if (!this.showArticleRename && !this.showArticlePriority && !this.showArticleFunnel && !this.showArticleStatus) {
        const actions = []
        if (this.selectedArticles.length > 1) {
          actions.push({ text: 'Merge', event: 'merge-articles', loading: this.isLoading.mergeArticles })
        }
        actions.push(
          { text: 'Move to hub', event: 'show-article-move' },
          { text: 'Favorite', event: 'favorite-articles', loading: this.isLoading.addToMap },
          { text: 'Dismiss clusters', event: 'dismiss-articles', loading: this.isLoading.dismissArticles }
        )
        return actions
      }
      return []
    },
    // Title for articles snackbar
    articleTitle () {
      return `${this.selectedArticles.length} ${this.selectedArticles.length > 1 ? 'Clusters' : 'Cluster'} selected`
    },
    // Actions for add article snackbar
    addArticleActions () {
      return [
        {
          text: `Add Cluster ${this.articleAddAndMoveKeyword ? 'and move' : ''}`,
          event: 'add-new-article',
          loading: this.isLoading.newArticle,
          disabled: !this.articleNewName || !this.articleAddForm
        }
      ]
    },
    // Actions for add topic snackbar
    topicPostActions () {
      return [
        {
          text: `Add hub ${this.topicAddAndMoveArticle ? 'and move' : ''}`,
          event: 'add-new-topic',
          loading: this.isLoading.topicPost,
          disabled: !this.topicNewName || !this.topicAddForm
        }
      ]
    },
    // Actions for rename topic snackbar
    renameTopicActions () {
      return [
        {
          text: 'Rename hub',
          event: 'rename-topic',
          loading: this.isLoading.renameTopic,
          disabled: !this.topicNewName
        }
      ]
    },
    // Actions for exclude topic snackbar
    excludeTopicActions () {
      return [
        {
          text: 'Exclude hub',
          event: 'exclude-topic',
          loading: this.isLoading.excludeTopic
        }
      ]
    },
    // Actions for delete topic snackbar
    deleteTopicActions () {
      return [
        {
          text: 'Delete hub',
          event: 'delete-topic',
          loading: this.isLoading.deleteTopic
        }
      ]
    }
  },
  watch: {
    async $route () {
      await this.loadData()
    },
    async tableArticlesOptions () {
      await this.mutateArticles()
    }
  },
  methods: {
    parseData,
    tooltips,
    ...mapActions([
      'articleGet',
      'topicGetList',
      'keywordPut',
      'topicPost',
      'topicPut',
      'articlePut',
      'articlePost',
      'loadScoreAndCommit',
      'loadArticleUrls',
      'recalculateAlerts'
    ]),

    ...mapMutations([
      'topicNew',
      'topicRename',
      'topicExclude',
      'keywordMoveCluster',
      'keywordExclude',
      'removeArticle',
      'articleMove',
      'articleChangeTag',
      'pageExclude',
      'pageMatchLock',
      'pageMatchUpdate'
    ]),

    // RENDER DATA
    async loadData () {
      try {
        this.isLoading.articles = true
        this.tableArticles.isLoading = true
        document.title = 'Plan | ContentGecko'
        this.articlePage = 1
        await Promise.all([
          this.topicGetList({
            contentplanId: this.contentplanId
          }),
          this.mutateArticles()
        ])
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading.articles = false
        this.tableArticles.isLoading = false
      }
    },
    async mutateArticles (delay) {
      if (this.isLoading.mutatingArticles) return
      this.isLoading.mutatingArticles = true
      this.tableArticles.isLoading = true
      this.isLoading.articles = true

      try {
        if (delay) {
          setTimeout(async () => {
            await this.articleGet(this.createFiltersObject)
            this.isLoading.mutatingArticles = false
            this.tableArticles.isLoading = false
            this.isLoading.articles = false
          }, delay)
        } else {
          await this.articleGet(this.createFiltersObject)
          this.isLoading.mutatingArticles = false
          this.tableArticles.isLoading = false
          this.isLoading.articles = false
        }
      } catch (error) {
        console.log(error)
        this.isLoading.mutatingArticles = false
      }
    },
    async loadNewArticles (isVisible) {
      if (!isVisible) return
      if (this.isLoading.keywords) return
      this.isLoading.articles = true
      this.articlePage++
      this.mutateArticles()
      this.isLoading.articles = false
    },
    async getScore () {
      if (this.selectedPages.length < 1 && this.selectedArticles.length < 1 && this.selectedKeywords.length < 2) return 'N/a'
      if (this.selectedArticles.length > 10 || this.selectedPages.length > 10) return 0

      this.isLoading.score = true

      await this.loadScoreAndCommit({
        contentplanId: this.contentplanId,
        articleId: this.selectedArticles?.length ? this.selectedArticles?.map(el => el.article_id) : this.selectedPages?.map(el => el.article_id),
        keywordId: this.selectedKeywords.map(el => el.keyword_id)
      })

      this.isLoading.score = false
    },
    getArticleKeywords (articleId) {
      if (!this.keywords || !this.articles || this.keywords?.meta?.counts) return []

      const tempKeywords = this.keywords
      if (!tempKeywords.length) return []

      return tempKeywords.filter(k => k.article_id === articleId)
    },
    actionChipColor (item) {
      if (!item) return
      const action = item.action ? item.action : item.suggested_action
      if (item.action) {
        if (action === 'leave') return 'green lighten-5'
        if (action === 'delete') return 'red lighten-5'
        if (action === 'merge') return 'pink lighten-5'
        if (action === 'update') return 'orange lighten-5'
      }
      if (item.suggested_action) {
        if (action === 'leave') return 'green lighten-4'
        if (action === 'delete') return 'red lighten-4'
        if (action === 'merge') return 'pink lighten-4'
        if (action === 'update') return 'orange lighten-4'
      }
    },
    formatDate (date) {
      if (!date) return
      return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
    },
    suggestedActionText (action) {
      return this.actions.find(a => a.value === action)?.text
    },
    capitalizeFirstChar (string) {
      if (!string?.length) return
      return string.charAt(0).toUpperCase() + string.slice(1)
    },

    // QUICK FILTERS
    selectedMetricIcon (metric) {
      if (!this.selectedMetrics?.map(m => m.value)?.includes(metric.value)) return
      if (this.selectedMetrics[0]?.value === metric.value) return 'mdi-numeric-1'
      if (this.selectedMetrics[1]?.value === metric.value) return 'mdi-numeric-2'
    },
    async handleSelectedMetrics (metric) {
      if (this.selectedMetrics?.map(m => m.value)?.includes(metric.value)) {
        this.selectedMetrics = this.selectedMetrics.filter(m => m.value !== metric.value)
      } else if (this.selectedMetrics.length === 2) {
        this.selectedMetrics[1] = metric
      } else {
        this.selectedMetrics.push(metric)
      }

      this.controlTableHeaders()
    },
    selectedDimensionIcon (dimension) {
      if (!this.selectedDimensions?.map(d => d.value)?.includes(dimension.value)) return
      if (this.selectedDimensions[0]?.value === dimension.value) return 'mdi-numeric-1'
      if (this.selectedDimensions[1]?.value === dimension.value) return 'mdi-numeric-2'
    },
    async handleSelectedDimensions (dimension) {
      if (this.selectedDimensions?.map(d => d.value)?.includes(dimension.value)) {
        this.selectedDimensions = this.selectedDimensions.filter(d => d.value !== dimension.value)
      } else if (this.selectedDimensions.length === 2) {
        this.selectedDimensions[1] = dimension
      } else {
        this.selectedDimensions.push(dimension)
      }

      this.controlTableHeaders()
    },
    controlTableHeaders () {
      this.tableArticles.headers = [
        { text: 'URL', value: 'article_url' },
        { text: 'Cluster', value: 'title' }
      ]

      if (this.selectedDimensions.length) {
        this.tableArticles.headers.push(...this.selectedDimensions.map(d => ({ text: d.text, value: d.value })))
      }
      if (this.selectedMetrics.length) {
        this.tableArticles.headers.push(...this.selectedMetrics.map(m => ({ text: m.text, value: m.value })))
      }
      this.tableArticles.headers.push({ text: 'Actions', value: 'actions' })
      this.tableArticlesOptions.sortBy = [this.selectedMetrics[0].value]
    },
    async toggleTrending () {
      this.trending = !this.trending
      this.handleSelectedMetrics({
        text: 'Cluster Impressions Change',
        value: 'google_impressions_change'
      })
    },
    async toggleLosing () {
      this.losing = !this.losing
      this.handleSelectedMetrics({
        text: 'Cluster Impressions Change',
        value: 'google_impressions_change'
      })
    },
    addMetricFilter (metric) {
      if (typeof metric.min === 'undefined') metric.min = null
      if (typeof metric.max === 'undefined') metric.max = null
      this.metricFilters.push(metric)
    },
    removeMetricFilter (metric) {
      this.metricFilters = this.metricFilters.filter(m => m.value !== metric.value)
      this.mutateArticles()
    },
    addDimensionFilter (dimension) {
      if (!dimension.filter) dimension.filter = dimension.type === 'date' ? [null, null] : null
      this.dimensionFilters.push(dimension)
    },
    removeDimensionFilter (dimension) {
      this.dimensionFilters = this.dimensionFilters.filter(d => d.value !== dimension.value)
      this.mutateArticles()
    },
    async applyShortcut (filter) {
      this.selectedNewPageShortcut = filter
      this.newOrExistingFilter = 'new'
      await this.resetFilters()

      if (filter === 'recently-added') {
        const today = new Date()
        const lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7)
        const lastWeekString = lastWeek.toISOString().split('T')[0]
        // add filter
        this.addDimensionFilter({
          text: 'Created at',
          value: 'created_at',
          type: 'date',
          filter: [lastWeekString, null]
        })
        // add created_at to dimensions
        this.handleSelectedDimensions({
          text: 'Created at',
          value: 'created_at'
        })
        // sort by created_at
        this.tableArticlesOptions.sortBy = ['created_at']
        this.tableArticlesOptions.sortDesc = [true]
      }

      if (filter === 'breakout-pages') {
        console.log('breakout-pages')
        console.log('current filtres', this.metricFilters, this.dimensionFilters)
        console.log('current selected metrics', this.selectedMetrics, this.selectedDimensions)
        // add sort
        this.tableArticlesOptions.sortBy = ['google_impressions_last']
        this.tableArticlesOptions.sortDesc = [true]
        console.log('changed sort', this.tableArticlesOptions.sortBy, this.tableArticlesOptions.sortDesc)
      }

      if (filter === 'zero-impressions') {
        // add filter
        this.addMetricFilter({
          text: 'Cluster Impressions',
          value: 'google_impressions_last',
          ranges: [0, 100, 1000, 10000],
          min: 0,
          max: 0
        })

        // add sort
        this.tableArticlesOptions.sortBy = ['relevance']
        this.tableArticlesOptions.sortDesc = [true]
      }

      if (filter === 'not-mapped') {
        // add filter
        this.addDimensionFilter({
          text: 'Mapped',
          value: 'show_in_map',
          type: 'select',
          options: [{ text: 'Yes', value: true }, { text: 'No', value: false }],
          filter: false
        })

        // add sort
        this.tableArticlesOptions.sortBy = ['relevance']
        this.tableArticlesOptions.sortDesc = [true]
      }

      console.log('getting new articles')
      await this.mutateArticles()
    },
    async resetFilters () {
      this.metricFilters = [
        { text: 'Search Volume', value: 'estimated_search_volume', ranges: [0, 100, 1000, 10000], min: null, max: null },
        { text: 'Potential Clicks', value: 'potential_clicks', ranges: [0, 100, 1000, 10000], min: null, max: null }
      ]

      this.dimensionFilters = [
        { text: 'Publish date', value: 'published_at', type: 'date', filter: [null, null] },
        { text: 'Priority', value: 'priority', type: 'select', options: priorities, filter: ['high', 'not set'] }
      ]

      this.selectedMetrics = [
        { text: 'Relevance', value: 'relevance' },
        { text: 'Search Volume', value: 'estimated_search_volume' }
      ]

      this.selectedDimensions = [
        { text: 'Status', value: 'status' },
        { text: 'Page type', value: 'type' }
      ]

      this.tableArticlesOptions.sortBy = ['relevance']
      this.tableArticlesOptions.sortDesc = [true]
      this.controlTableHeaders()
    },

    // ACTIONS - GENERAL
    async recalculate () {
      this.isLoading.alerts = true
      try {
        await this.recalculateAlerts({
          contentplanId: this.contentplanId
        })
      } catch (e) {
        console.log(e)
      }
      this.isLoading.alerts = 'refresh'
    },

    // ACTIONS - KEYWORDS
    async moveSelectedKeywords (articleId) {
      const moveToId = articleId || this.keywordsNewArticle
      if (this.selectedKeywords?.length === 0 || !moveToId) return

      this.isLoading.moveKeywords = true

      try {
        await this.keywordPut({
          contentplanId: this.contentplanId,
          keywordIds: this.selectedKeywords.map(el => el.keyword_id),
          articleId: moveToId,
          action: 'move'
        })
        this.mutateArticles()
        this.selectedKeywords = []
        // Close the move form if it was opened
        if (this.showKeywordMove) {
          this.showKeywordMove = false
          this.keywordsNewArticle = null
        }

        this.isLoading.moveKeywords = false
        await this.recalculate()
      } catch (e) {
        console.log(e)
        this.isLoading.moveKeywords = false
      }
    },
    async excludeSelectedKeywords () {
      if (this.selectedKeywords?.length === 0) return

      this.isLoading.excludeKeyword = true
      const keywordIds = this.selectedKeywords.map(el => el.keyword_id)

      try {
        await this.keywordPut({
          contentplanId: this.contentplanId,
          keywordIds,
          action: 'exclude'
        })
        this.mutateArticles()
        this.selectedKeywords = []

        this.isLoading.excludeKeyword = false
        await this.recalculate()
      } catch (e) {
        console.log(e)
      }
    },
    async resetKeywords (keywordId) {
      if (!this.selectedKeywords?.length && !keywordId) return

      this.isLoading.resetKeyword = true
      const selectedKeywordIds = this.selectedKeywords.map(el => el.keyword_id)

      const keywordIds = keywordId ? [keywordId] : selectedKeywordIds

      try {
        await this.keywordPut({
          contentplanId: this.contentplanId,
          keywordIds,
          action: 'reset'
        })
        this.mutateArticles()
        this.selectedKeywords = []

        await this.recalculate()
        this.isLoading.resetKeyword = false
      } catch (e) {
        console.log(e)
      }
    },

    // ACTIONS - ARTICLES
    async mergeSelectedArticles (mergeToId, mergeFromId) {
      if (this.selectedArticles?.length === 0 && (!mergeToId || !mergeFromId)) return

      let mergeToArticleId = mergeToId
      let mergeFromArticleIds = [mergeFromId]
      if (!mergeToArticleId || !mergeFromArticleIds?.length) {
        this.selectedArticles.sort((a, b) => {
          return b.estimated_search_volume - a.estimated_search_volume
        })

        const deleteArticles = this.selectedArticles.map(a => a.article_id)
        deleteArticles.shift()

        mergeToArticleId = this.selectedArticles[0].article_id
        mergeFromArticleIds = deleteArticles
        console.log('mergeSelectedArticles', mergeToArticleId, mergeFromArticleIds)
      }
      if (!mergeToArticleId || !mergeFromArticleIds?.length) return

      this.isLoading.mergeArticles = mergeFromId || true
      try {
        await this.articlePut({
          contentplanId: this.contentplanId,
          action: 'merge',
          articleIdsFrom: mergeFromArticleIds,
          articleIdTo: mergeToArticleId
        })
        this.mutateArticles()

        this.selectedArticles = []
        this.isLoading.mergeArticles = false
        await this.recalculate()
      } catch (e) {
        console.log(e)
      }
    },
    async moveSelectedArticles (articleId, topicId) {
      if ((this.selectedArticles?.length === 0 || !this.articlesNewTopicId) && (!articleId || !topicId)) return

      const articlesToMove = articleId ? [articleId] : this.selectedArticles.map(el => el.article_id)
      const newTopic = topicId || this.articlesNewTopicId

      if (!articlesToMove?.length || !newTopic) return
      this.isLoading.moveArticles = articleId || true

      try {
        await this.articlePut({
          workspaceId: this.workspaceId,
          contentplanId: this.contentplanId,
          action: 'updateTopic',
          articleIds: articlesToMove,
          topicId: newTopic
        })
        this.mutateArticles()

        this.selectedArticles = []
        this.isLoading.moveArticles = false
      } catch (e) {
        console.log(e)
      }
    },
    async excludeSelectedArticles (articleId) {
      const articleIds = articleId ? [articleId] : this.selectedArticles.map(el => el.article_id)
      if (articleIds?.length === 0) return

      this.isLoading.deleteArticles = true

      try {
        await this.articlePut({
          workspaceId: this.workspaceId,
          contentplanId: this.contentplanId,
          action: 'delete',
          articleIds
        })
        this.mutateArticles()

        this.selectedArticles = []
        this.isLoading.deleteArticles = false
        await this.recalculate()
      } catch (e) {
        console.log(e)
      }
    },
    async favoriteSelectedArticles (article, value = true) {
      console.log('favoriteSelectedArticles', article, value)
      const articleIds = article ? [article.article_id] : this.selectedArticles.map(el => el.article_id)
      if (articleIds?.length === 0) return

      this.isLoading.addToMap = article?.article_id || true

      try {
        await this.articlePut({
          workspaceId: this.workspaceId,
          contentplanId: this.contentplanId,
          action: value ? 'addToMap' : 'removeFromMap',
          articleIds
        })
        this.mutateArticles()

        this.selectedArticles = []
        this.isLoading.addToMap = false
      } catch (e) {
        console.log(e)
      }
    },
    async dismissSelectedArticles (articleId) {
      const articleIds = articleId ? [articleId] : this.selectedArticles.map(el => el.article_id)
      if (articleIds?.length === 0) return

      this.isLoading.dismissArticles = articleId || true

      try {
        await this.articlePut({
          workspaceId: this.workspaceId,
          contentplanId: this.contentplanId,
          action: 'updatePriority',
          priority: 'low',
          articleIds
        })
        await this.removeArticle({
          articleIds
        })
        this.mutateArticles()

        this.selectedArticles = []
        this.isLoading.dismissArticles = false
      } catch (e) {
        console.log(e)
      }
    },
    async addNewArticle () {
      if (!this.articleNewName) return
      this.isLoading.newArticle = true

      try {
        const newArticleId = await this.articlePost({
          contentplanId: this.contentplanId,
          topicId: this.topicFilter || this.topics.map(t => t.id)[0],
          name: this.articleNewName
        })
        if (this.articleAddAndMoveKeyword) {
          await this.moveSelectedKeywords(newArticleId?.id)
        } else {
          this.mutateArticles()
        }
        this.showArticleAdd = false
        this.articleNewName = null
        this.articleAddAndMoveKeyword = false
        this.showKeywordMove = false
        this.selectedKeywords = []
        this.isLoading.newArticle = false
      } catch (e) {
        console.log(e)
        this.isLoading.newArticle = false
      }
    },

    // ACTIONS - TOPICS
    async addNewTopic () {
      if (!this.topicNewName) return
      this.isLoading.topicPost = true

      try {
        const newTopicId = await this.topicPost({
          contentplanId: this.contentplanId,
          name: this.topicNewName
        })
        this.topicNew({
          topicId: newTopicId?.id,
          name: this.topicNewName,
          contentplanId: this.contentplanId
        })
        if (this.topicAddAndMoveArticle) {
          this.articlesNewTopicId = newTopicId?.id
          await this.moveSelectedArticles()
        }
        this.showTopicAdd = false
        this.showArticleMove = false
        this.topicNewName = null
        this.selectedArticles = []
        this.topicAddAndMoveArticle = false
        this.articlesNewTopicId = null
        this.isLoading.topicPost = false
      } catch (e) {
        console.log(e)
        this.isLoading.topicPost = false
      }
    },
    async renameTopic (topicId) {
      if (!this.topicNewName) return

      this.isLoading.renameTopic = true
      const topicIds = topicId || this.selectedTopic
      if (!topicIds) return

      try {
        await this.topicPut({
          workspaceId: this.workspaceId,
          contentplanId: this.contentplanId,
          topicIds,
          name: this.topicNewName,
          action: 'rename'
        })
        this.topicRename({
          topicId: topicIds,
          name: this.topicNewName
        })

        this.selectedTopic = null
        this.showTopicRename = false
        this.topicNewName = null
        this.isLoading.renameTopic = false
      } catch (e) {
        console.log(e)
      }
    },
    async excludeTopic () {
      if (!this.selectedTopic) return
      this.isLoading.excludeTopic = true

      try {
        await this.topicPut({
          workspaceId: this.workspaceId,
          contentplanId: this.contentplanId,
          topicIds: this.selectedTopic,
          action: 'exclude'
        })
        this.topicExclude({
          topicIds: [this.selectedTopic]
        })
        this.mutateArticles()

        this.selectedTopic = null
        this.showTopicExclude = false
        this.topicFilter = null
        this.isLoading.excludeTopic = false
        await this.recalculate()
      } catch (e) {
        console.log(e)
      }
    },
    async deleteTopic (topicId) {
      const topicIds = topicId || this.selectedTopic
      if (!topicIds) return

      this.isLoading.deleteTopic = true

      try {
        await this.topicPut({
          workspaceId: this.workspaceId,
          contentplanId: this.contentplanId,
          topicIds,
          action: 'delete'
        })
        this.topicExclude({
          topicIds: [topicIds]
        })
        this.mutateArticles()

        this.selectedTopic = null
        this.showTopicReset = false
        this.topicFilter = null
        this.isLoading.deleteTopic = false
      } catch (e) {
        console.log(e)
      }
    },

    // ACTIONS - SELECTION
    async handleCheckboxClick (keyword, article, page) {
      if (keyword) {
        this.selectedArticles = []
        this.selectedPages = []
        const index = this.selectedKeywords.findIndex(el => el.keyword_id === keyword.keyword_id)
        if (index === -1) {
          this.selectedKeywords.push(keyword)
        } else {
          this.selectedKeywords.splice(index, 1)
        }
      }
      if (article) {
        this.selectedKeywords = []
        this.selectedPages = []
        const index = this.selectedArticles.findIndex(el => el.article_id === article.article_id)
        if (index === -1) {
          this.selectedArticles.push(article)
        } else {
          this.selectedArticles.splice(index, 1)
        }
        if (this.selectedArticles?.length === 1) {
          this.articleNewName = article.title
        }
      }
      if (page) {
        this.selectedKeywords = []
        this.selectedArticles = []
        const index = this.selectedPages.findIndex(el => el.page_id === page.page_id)
        if (index === -1) {
          this.selectedPages.push(page)
        } else {
          this.selectedPages.splice(index, 1)
        }
      }

      this.getScore()
    },
    async handleSelectAllClick () {
      if (this.selectAllArticles) {
        this.selectedArticles = this.articles
      } else {
        this.selectedArticles = []
      }

      this.getScore()
    },
    handleExistingPagesClick () {
      if (this.actionFilter) {
        this.actionFilter = ''
        this.mutateArticles()
        return
      }
      this.newOrExistingFilter = this.newOrExistingFilter !== 'existing' ? 'existing' : null
      this.mutateArticles()
    },
    handleNewPagesClick () {
      this.actionFilter = ''
      this.newOrExistingFilter = this.newOrExistingFilter !== 'new' ? 'new' : null
      this.mutateArticles()
    },
    handleMetricFilterChipClick (metric, i) {
      console.log(metric, i)

      // write metric min/max values to this.metricFilters array based on index of ranges
      this.metricFilters.map(m => {
        if (m.value === metric.value) {
          m.min = metric.ranges[i - 1]
          m.max = metric.ranges[i]
        }

        return m
      })

      this.mutateArticles()
    },
    handleGridViewSwitch () {
      if (this.switchGridView) {
        this.mutateArticles()
      }
    },
    isKeywordSelected (keywordId) {
      return this.selectedKeywords.some(el => el.keyword_id === keywordId)
    },
    isArticleSelected (articleId) {
      return this.selectedArticles.some(el => el.article_id === articleId)
    },
    isPageSelected (pageId) {
      return this.selectedPages.some(el => el.page_id === pageId)
    },
    async loadArticleUrlsSelection (articleId) {
      this.isLoading.articleUrls = true

      await this.loadArticleUrls({
        articleId
      })
      this.selectableTargetUrls = this.articleUrls
      // console.log('this.articleUrls', this.articleUrls)

      // this.selectableTargetUrls = this.articles.filter(u => u.article_id !== articleId)
      // console.log('this.selectableTargetUrls', this.selectableTargetUrls)
      // this.selectableTargetUrls = this.selectableTargetUrls.map(iu => {
      //   const urlWithImpressions = this.articleUrls.filter(u => u.page_id === iu.page_id)
      //   console.log('urlWithImpressions', urlWithImpressions)
      //   if (urlWithImpressions.length > 0) {
      //     return { ...iu, impressions: urlWithImpressions[0].impressions }
      //   }
      //   return { ...iu, impressions: 0 }
      // })

      // this.selectableTargetUrls.sort((a, b) => {
      //   if (a.impressions > b.impressions) return -1
      //   if (a.impressions < b.impressions) return 1
      //   if (a.article_id < b.article_id) return -1
      //   if (a.article_id > b.article_id) return 1
      //   return 0
      // })
      // console.log('this.selectableTargetUrls', this.selectableTargetUrls)

      this.isLoading.articleUrls = false
    }
  },
  async mounted () {
    await this.loadData()
  }
}
